module.exports = "<p>\r\n  data-admin works!\r\n</p>\r\n"